import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  styled,
} from "@mui/material";
import DarkPrimaryButton from "../../component/PrimaryButton/DarkPrimaryButton";
import { useEffect } from "react";
import { palette } from "../../themes/theme";

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  color: palette.text.dark,
}));

const ExportWidthAndHeight = {
  full: {
    large: {
      width: "100%",
      height: "100%",
    },
    medium: {
      width: "100%",
      height: "100%",
    },
  },
  landscape: {
    large: {
      width: "100%",
      height: "80%",
    },
    medium: {
      width: "85%",
      height: "65%",
    },
  },
  portrait: {
    large: {
      width: "60%",
      height: "100%",
    },
    medium: {
      width: "50%",
      height: "80%",
    },
  },
};

const ExportSettings = ({
  exportChanges,
  handleClose,
  exportSettingsData,
  setExportSettingsData,
}) => {
  const handleChange = (key, value) => {
    const newObj = { ...exportSettingsData };
    newObj[key] = value;

    newObj.width = ExportWidthAndHeight[newObj.orientation][newObj.size].width;
    newObj.height =
      ExportWidthAndHeight[newObj.orientation][newObj.size].height;

    newObj.y = `calc((100% - ${newObj.height}) / 2)`;
    newObj.x = `calc((100% - ${newObj.width}) / 2)`;

    setExportSettingsData(newObj);
  };

  useEffect(() => {
    document.getElementsByClassName(
      "mapboxgl-ctrl-bottom-right"
    )[0].style.display = "none";

    return () => {
      if (
        document.getElementsByClassName("mapboxgl-ctrl-bottom-right")?.[0]
          ?.style?.display
      ) {
        document.getElementsByClassName(
          "mapboxgl-ctrl-bottom-right"
        )[0].style.display = "";
      }
    };
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 1 }}>
      <FormControl fullWidth>
        <InputLabel>Size</InputLabel>
        <Select
          sx={{ color: palette.text.dark }}
          value={exportSettingsData.size}
          label="Size"
          onChange={(e) => handleChange("size", e.target.value)}
          disabled={exportSettingsData.orientation === "full"}
        >
          <CustomMenuItem value={"large"}>11 x 17</CustomMenuItem>
          <CustomMenuItem value={"medium"}>8.5 x 11</CustomMenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth>
        <InputLabel>Orientation</InputLabel>
        <Select
          sx={{ color: palette.text.dark }}
          value={exportSettingsData.orientation}
          label="Orientation"
          onChange={(e) => handleChange("orientation", e.target.value)}
        >
          <CustomMenuItem value={"full"}>Visible Map</CustomMenuItem>
          <CustomMenuItem value={"portrait"}>Portrait</CustomMenuItem>
          <CustomMenuItem value={"landscape"}>Landscape</CustomMenuItem>
        </Select>
      </FormControl>
      {/* <FormControl fullWidth>
        <InputLabel>Format</InputLabel>
        <Select
          sx={{ color: palette.text.dark }}
          value={exportSettingsData.format}
          label="Format"
          onChange={(e) => handleChange("format", e.target.value)}
        >
          <CustomMenuItem value={"png"}>PNG</CustomMenuItem>
          <CustomMenuItem value={"jpeg"}>JPEG</CustomMenuItem>
          <CustomMenuItem value={"svg"}>SVG</CustomMenuItem>
          <CustomMenuItem value={"pdf"}>PDF</CustomMenuItem>
        </Select>
      </FormControl> */}
      {/* <FormControl fullWidth>
        <InputLabel>DPI</InputLabel>
        <Select
          sx={{ color: "white" }}
          value={exportSettingsData.dpi}
          label="DPI"
          onChange={(e) => handleChange("dpi", e.target.value)}
        >
          <CustomMenuItem value={400}>400</CustomMenuItem>
        </Select>
      </FormControl> */}

      <Box sx={{ display: "flex", alignSelf: "end", gap: 2, p: 2 }}>
        <Button
          variant="outlined"
          sx={{ px: 2, fontWeight: "bold", borderRadius: "0px" }}
          onClick={exportChanges}
        >
          Export
        </Button>
        <Button
          variant="outlined"
          sx={{ px: 2, fontWeight: "bold", borderRadius: "0px" }}
          onClick={handleClose}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default ExportSettings;
